
import { RevTag } from '@ds/components/Tag'

import FormattedMessage from '@i18n/components/FormattedMessage'

import translations from './InstallmentPaymentPrice.translations'

export default {
  components: {
    FormattedMessage,
    RevTag,
  },

  props: {
    monthlyPaymentPlan: {
      type: Object,
      validator: (monthlyPaymentPlan) =>
        Object.prototype.hasOwnProperty.call(
          monthlyPaymentPlan,
          'annualPercentageRate',
        ) &&
        Object.prototype.hasOwnProperty.call(
          monthlyPaymentPlan,
          'monthlyPrice',
        ) &&
        Object.prototype.hasOwnProperty.call(
          monthlyPaymentPlan,
          'numberOfMonths',
        ),
      required: true,
    },
    shouldDisplayOnTwoLines: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    translations: () => translations,

    price() {
      return this.$t(translations.pricePerMonth, {
        amount: this.$t.price(this.monthlyPaymentPlan.monthlyPrice),
      })
    },
  },
}
